import '../global.js';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import 'simplebar/dist/simplebar.css';
import LocomotiveScroll from 'locomotive-scroll';
import 'jquery.marquee';


gsap.registerPlugin(ScrollTrigger);

export const MobileNav = () => {
	var navopener = $('.nav-opener'),
		navwrap = $('.nav-slide'),
		links = navwrap.find('a'),
		navactive = 'nav-active',
		navout = 'nav-close';

	navopener.click(function () {
		$('body').toggleClass(navactive);

		if ($(this).hasClass('close')) {
			$('body').addClass(navout);
			setTimeout(() => {
				$('body').removeClass(navout);
			}, 1001);
		}
	});

	// add arrow icon to menu items
	const menuItems = document.querySelectorAll('.main-nav li > a');
	if (menuItems) {
		menuItems.forEach((item) => {
			item.insertAdjacentHTML('beforeend', '<i class="arrow-right"></i>');
		});
	}

	$('.main-nav li').each(function (i) {
		var item = $(this);
		var drop = item.find('ul');
		var link = item.find('a').eq(0);
		if (drop.length) {
			item.addClass('hasdrop');
			if (link.length)
				link
					.addClass('hasdrop-a')
					.attr({'data-more': '', 'data-outside': ''});
		}
		item[0].style = '--index:' + i
	});

	links.click(function () {
		$(this).hasClass('hasdrop-a') ? false : $('body').removeClass(navactive);
	});


	const navHeight = () => {
		const winH = window.innerHeight || document.documentElement.clientHeight;
		const nav = document.querySelector('.nav-slide');
		nav?.style.setProperty('height', winH + 'px');
	};

	navHeight();
	window.addEventListener('resize', navHeight);
};

export const OpenClose = () => {
	const clickDataMoreHandler = function (e) {
		e.preventDefault();
		$(this).hasClass('active')
			? $(this).removeClass('active')
			: $(this).addClass('active');
		$(this).next().stop().slideToggle(200);
	};

	const clickDataOutsideHandler = function (e) {
		$('[data-outside]').not(this).removeClass('active').next().slideUp(200);
	};

	const htmlClickHandler = function (e) {
		var target = $(e.target);

		if (
			!target.closest('[data-outside]').length &&
			!target.closest('[data-outside] + *').length
		) {
			setTimeout(function () {
				$('[data-outside]').removeClass('active').next().slideUp(200);
			}, 200);
		}
	};

	// Remove existing handlers
	$(document).off('click', '[data-more]', clickDataMoreHandler);
	$(document).off('click', '[data-outside]', clickDataOutsideHandler);
	$('html').off('click touchstart pointerdown MSPointerDown', htmlClickHandler);

	// Add new handlers
	$('[data-more]').next().hide();
	$('[data-more].active').next().show();

	$(this).hasClass('active')
		? $(this).removeClass('active')
		: $(this).addClass('active');

	$(document).on('click', '[data-more]', clickDataMoreHandler);
	$(document).on('click', '[data-outside]', clickDataOutsideHandler);
	$('html').on('click touchstart pointerdown MSPointerDown', htmlClickHandler);

	$('.block-holder').each(function() {
        var $holder = $(this);
        var $toggleLink = $holder.find('.block.drop-open');
        var $box = $holder.find('.lts-drop');

        $toggleLink.on('click', function (e) {
			e.preventDefault();
			$box.toggleClass('visible');
			$('body').toggleClass('drop-active', $box.hasClass('visible'));
			if ($(window).width() <= 768) {
				$('body').css('overflow', 'hidden');
			}
		});

		$('.modal-close-btn').on('click', function (e) {
			e.preventDefault();
			$box.removeClass('visible');
			$box.hide();
			$('.drop-open').removeClass('active');
			$('body').css('overflow', 'auto');
		});

        $(document).on('click', function(e) {
            if (!$holder.is(e.target) && $holder.has(e.target).length === 0) {
                if ($box.hasClass('visible')) {
                    $box.removeClass('visible');
                    $('body').removeClass('drop-active');
                }
            }
        });
    });
};

export const destroyOpenClose = () => {
	// Cleanup
	$(document).off('click', '[data-more]');
	$(document).off('click', '[data-outside]');
	$('html').off('click touchstart pointerdown MSPointerDown');
};

export const HoverClassOnParent = (
	selector = '[data-accordion-trigger]',
	parent = '[data-accordion]'
) => {
	const item = document.querySelectorAll(selector);

	Array.from(item).forEach((el) => el.classList.remove('hover'));

	item.forEach((el) => {
		'mouseenter focusin'.split(' ').forEach((e) => {
			el.addEventListener(e, () => {
				el.closest(parent)?.classList.add('hover');
			});
		});

		'mouseout focusout'.split(' ').forEach((e) => {
			el.addEventListener(e, () => {
				el.closest(parent)?.classList.remove('hover');
			});
		});
	});
};

export const OpenCloseNew = () => {
	const firstAccordion = $('[data-accordion] [data-more]')[0];
	firstAccordion?.classList.add('active');
	$('[data-more]').next().hide();
	$('[data-more].active').next().show();
};

export const CustomSelect = () => {
	jQuery('[data-select]').each(function () {
		var item = jQuery(this),
			selectDrop = item.next(),
			linkItems = selectDrop.find('a');

		item.attr({'data-outside': '', 'data-more': ''});

		linkItems.on('click', function (e) {
			e.preventDefault();
			item.text(jQuery(this).text());
			selectDrop.slideUp(200);
			item.removeClass('active').addClass('selected');
			selectDrop.find('li').removeClass('active');
			jQuery(this).parent().addClass('active');
		});

		if (selectDrop.children().hasClass('active')) {
			item
				.text(jQuery(this).next().find('.active a').text())
				.addClass('selected');
		}
	});
};

export const Tabs = () => {
	$('[data-tab]').click(function (e) {
		e.preventDefault();
		var tab_id = $(this).attr('data-tab');

		$(this).parent().siblings().find('[data-tab]').removeClass('active');
		$('#' + tab_id)
			.siblings()
			.removeClass('active');

		$(this).addClass('active');
		$('#' + tab_id).addClass('active');
	});
	$('#' + $('[data-tab].active').data('tab')).addClass('active');
};


export const Filter = () => {
	$('body')
		.find('[data-close]')
		.on('click', function (e) {
			e.preventDefault();
			//$('body').removeClass('filter--active');
			 enableScrollingOnIos(()=>{
			 	$('body').removeClass('filter--active');
			 });



		});
};

export const LinkBackBlog = () => {
	$('body')
		.find('[data-back-blog]')
		.on('click', function () {
			const url = new URL(window.location.href);
			const prev = new URL(document.referrer);

			window.location.replace(prev);
		});
};


export const BrowserOsClass = () => {
	// Get OS
	var os = ['iphone', 'ipad', 'windows', 'mac', 'linux'];

	var match = navigator.appVersion
		.toLowerCase()
		.match(new RegExp(os.join('|')));
	if (match) {
		$('body').addClass(match[0]);
	}
};

export const HomeHeroImages = (data) => {
	return new Promise((resolve, reject) => {
		try {
			let featuredSequences;
			const featuredSequencesElement =
				data.next.container.querySelector('#featuredSequences');

			if (featuredSequencesElement) {
				try {
					featuredSequences = JSON.parse(
						featuredSequencesElement.text
					);
					window.featuredSequences = featuredSequences;
				} catch (e) {
					console.error('Error parsing featuredSequences:', e);
				}
			}

			if (!featuredSequences || featuredSequences.length === 0) {
				const nextScripts =
					data.next.container.querySelectorAll('[data-script]');
				nextScripts.forEach((script) => {
					if (!script.src) {
						const newScript = document.createElement('script');
						newScript.innerHTML = script.innerHTML;
						document.body.appendChild(newScript);
					}
					script.remove();
				});

				return resolve(null);
			}

			let featuredImages;
			const hasSeenNewImages =
				localStorage.getItem('hasSeenNewImages') === 'true';

			if (!hasSeenNewImages) {
				featuredImages = featuredSequences[0];
				localStorage.setItem('hasSeenNewImages', 'true');
			} else {
				const showNewImages = Math.random() < 0.7;

				if (showNewImages) {
					featuredImages = featuredSequences[0];
				} else {
					featuredImages =
						featuredSequences[
							Math.floor(Math.random() * featuredSequences.length)
						];
				}
			}

			const bannerText = document.querySelector(
				'.banner-type-2 .banner-text'
			);
			if (!bannerText) {
				console.error('Banner text element not found');
				return resolve(null);
			}

			const imagesWidth = ['229', '209', '344'];
			const imagesGradient = ['yellow', 'blue', 'red'];
			const imagesSpeed = ['1', '3.2', '5.2'];

			const images = [
				featuredImages.vertical_image_1,
				featuredImages.vertical_image_2,
				featuredImages.horizontal_image,
			];

			const companyUrls = [
				featuredImages.company_1_url,
				featuredImages.company_2_url,
				featuredImages.company_3_url,
			];

			images.forEach((image, i) => {
				if (!image || !image.url) {
					console.warn(`Image ${i} is missing or has no URL`);
					return;
				}

				const imageContainer = document.createElement('div');
				imageContainer.setAttribute('data-content-parallax', '');
				imageContainer.setAttribute('data-speed', '1');
				imageContainer.setAttribute('data-scroll', '');
				imageContainer.setAttribute(
					'data-scroll-speed',
					imagesSpeed[i]
				);
				imageContainer.style.pointerEvents = 'none';

				const companyUrl = companyUrls[i];
				const imageTag = `<img src="${image.url}" alt="${image.alt || ''}" width="${
					imagesWidth[i]
				}">`;

				imageContainer.innerHTML = `
				<div class="img-banner img-0${i + 1}" data-home-slideIn>
					<div class="wrapper" data-sequence="1">
					<div data-select-effect class="${imagesGradient[i]}-gradient">
						${companyUrl ? `<a href="${companyUrl}" style="pointer-events: auto; position: relative; z-index: 2; display: block; height: 100%;">${imageTag}</a>` : imageTag}
					</div>
					</div>
				</div>
				`;

				bannerText.parentNode.insertBefore(imageContainer, bannerText);
			});

			resolve(featuredImages);
		} catch (error) {
			console.error('Error in HomeHeroImages:', error);
			reject(error);
		}
	});
};


export const ResponsiveGradient = (container) => {
	var background = container.querySelector('.bg-about');

	if (background !== null) {
		var contentBlockHeight = container.querySelector('.news-feed').offsetHeight;
		background.style.height = contentBlockHeight + 'px';
	}
};


export const setupWidthLinks = () => {
	const links = document.querySelectorAll('.link');
	links.forEach((link) => {
		link.style.width = link.offsetWidth + 20 + 'px';
	});
}

export const FactionModal = () => {
	const triggers = $('[href^="#modal-faction"]')

	if (!triggers.length) return

	triggers.each(function () {
		$(this).click(function (e) {
			e.preventDefault()
			$('body').addClass('modal-faction-active')
			$('#modal-faction').addClass('show')
			return false;
		})
	})

	$('#modal-faction .modal-close-btn, #modal-faction .btn').click(function (e) {
		$('body').removeClass('modal-faction-active')
		$('#modal-faction').removeClass('show')
	})
}

export class RemoveImageBackground {
	static instance = null;

	static create(containers) {
		if (!RemoveImageBackground.instance) {
			RemoveImageBackground.instance = new RemoveImageBackground(containers);
		}
		return RemoveImageBackground.instance;
	}

	constructor(containers) {

		if (typeof containers === 'object' && containers.length > 0) {
			this.init(containers);
		}

	}

	init(containers) {

		containers.forEach((container) => {
			const selectors = container.querySelectorAll('img');

			selectors.forEach((item) => {

				if (typeof item.src === 'string' && item.src.length > 0 && !item.src.endsWith('.svg')) {
					this.removeBackground(item.src).then((newSrc) => {
						item.src = newSrc
					})
				}

			});

		});
	}

	static destroy() {
		RemoveImageBackground.instance = null;
	}

	async removeBackground(image) {
		const backgroundColor = {red: 255, green: 255, blue: 255};
		const threshold = 10;

		const imageElement = new Image();
		imageElement.src = image;
		await new Promise(function (resolve) {
			imageElement.addEventListener('load', resolve);
		});

		const canvas = document.createElement('canvas');
		canvas.width = imageElement.naturalWidth;
		canvas.height = imageElement.naturalHeight;

		const ctx = canvas.getContext('2d');
		ctx.drawImage(imageElement, 0, 0);
		const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		for (let i = 0; i < imageData.data.length; i += 4) {
			const red = imageData.data[i];
			const green = imageData.data[i + 1];
			const blue = imageData.data[i + 2];
			if (Math.abs(red - backgroundColor.red) < threshold &&
				Math.abs(green - backgroundColor.green) < threshold &&
				Math.abs(blue - backgroundColor.blue) < threshold) {
				imageData.data[i + 3] = 0;
			}
		}

		ctx.putImageData(imageData, 0, 0);
		return canvas.toDataURL(`image/png`);
	}

}

export const disableScrollingOnIos = (callback) => {
	if(callback) callback();
	setTimeout(() => {
		const body = document.querySelector('body');
		window.scroller.stop();
		window.filterScrollPosition = window.pageYOffset;
		body.style.overflow = 'hidden';
		body.style.position = 'fixed';
		body.style.top = `-${window.filterScrollPosition}px`;
		body.style.width = '100%';
	}, 0);
}

export const enableScrollingOnIos = (callback) => {
	const scrollPosition = window.filterScrollPosition || 0;
	const body = document.querySelector('body');
	body.style.removeProperty('overflow');
	body.style.removeProperty('position');
	body.style.removeProperty('top');
	body.style.removeProperty('width');
	window.scrollTo(0, scrollPosition);

	if (typeof window.scroller !== 'undefined') {
		window.scroller.start();
	}

	setTimeout(() => {
		if(callback) callback();
	}, 0);
}

export const detectOperatingSystem= () => {
	const userAgent = navigator.userAgent.toLowerCase();

	if (userAgent.indexOf('mac') !== -1) {
		return 'Mac';
	} else if (userAgent.indexOf('win') !== -1) {
		return 'Windows';
	} else {
		return 'Unknown';
	}
}

export const ExternalLink = () => {
	let currentDomain = window.location.hostname;

	function isSameDomain(link) {
		let linkDomain = link.hostname;
		return linkDomain === currentDomain || linkDomain.includes('lsvp.com');
	}

	$('a').each(function () {
		var link = $(this);
		if (!isSameDomain(this)) {
			link.attr('target', '_blank');
		}
	});

	$('a:contains(http)').addClass('a-break')
};

export const Modal = () => {
	$('[data-modal]:not([href="#game-theory"])').on('click', function () {
		$('body').addClass('modal-active');
		$('.modal').removeClass('show');
		let targetModal = $($(this).attr('href'));
		targetModal.removeAttr('style').addClass('show');

		let vimeoIframe = targetModal.find('iframe[src*="vimeo.com"]');
		if (vimeoIframe.length) {
			let vimeoPlayer = new Vimeo.Player(vimeoIframe[0]);
			vimeoPlayer.play().catch(function (error) {
				console.error('Error playing Vimeo video:', error);
			});
		}

		return false;
	});

	$('[data-modal][href="#game-theory"]').on('click', function (e) {
    e.preventDefault();
	pauseAllVideos(modal, false);
    $('.modal').removeClass('show').removeClass('fadein');

    $('.nl-podcast--inner').css({
        'pointer-events': 'none',
        'touch-action': 'none',
        'position': 'relative',
        'z-index': '-1'
    });

    const videoId = $(this).attr('video-id');
    const slideIndex = $(this).attr('data-index'); // Get the data-index attribute
    const modal = $('#game-theory');

    showModalAndPlay(modal, videoId, 0, slideIndex, true);


	$(document).on('click', 'a[swiper-video]', function (e) {
		e.preventDefault();

		const videoId = $(this).attr('video-id');
		const sliderElement = document.querySelector(
			'.modal-thumbnails-slider'
		);
		const clickedSlide = $(this).closest('.swiper-slide');

		// Change video in the embed area
		if (videoId && videoEmbedsData[videoId]) {
			// Get the embed code and modify it to include autoplay
			let embedCode = videoEmbedsData[videoId];

			// Add autoplay and mute parameters to help with autoplay restrictions
			embedCode = embedCode.replace(/src="([^"]+)/, function (match, p1) {
				if (p1.includes('?')) {
					return 'src="' + p1 + '&autoplay=0&mute=0&rel=0';
				} else {
					return 'src="' + p1 + '&autoplay=0&mute=0&rel=0';
				}
			});

			// Insert the modified embed code
			$('#video-embed-area').html(embedCode);

			// Get the iframe element
			const iframe = $('#video-embed-area iframe')[0];

			// Initialize YouTube player from the iframe
			const player = new YT.Player(iframe, {
				events: {
					onReady: function (event) {
						// Explicitly play the video when ready
						event.target.playVideo();

						// Attempt to unmute after a short delay
						setTimeout(function () {
							try {
								event.target.unMute();
								event.target.setVolume(80);
							} catch (e) {
								console.log('Could not unmute video:', e);
							}
						}, 1000);
					},
				},
			});

			// If Swiper is initialized, slide to the clicked thumbnail
			if (sliderElement && sliderElement.swiper) {
				const index = clickedSlide.data('index');
				if (index !== undefined) {
					sliderElement.swiper.slideTo(index, 300, false);
				}
			}
		}
	});

    return false;
});

// Function to show modal and play video
function showModalAndPlay(modal, videoId, startTime, slideIndex, slider) {
	if (modal.length) {
		if(slider){
			setTimeout(function() {
				modal.removeAttr('style').addClass('show');
				$('body').addClass('modal-active');

				requestAnimationFrame(() => {
					modal.addClass('fadein');
				})
			},300);
		} else {
			modal.removeAttr('style').addClass('show');
			$('body').addClass('modal-active');
			requestAnimationFrame(() => {
				modal.addClass('fadein');
			})
		}

		// Get the embed code and modify it to include autoplay and start time
		let embedCode = videoEmbedsData[videoId];

		// If we have a start time, add it to the iframe src
		if (startTime && startTime > 0) {
			embedCode = embedCode.replace(/src="([^"]+)/, function (match, p1) {
				if (p1.includes('?')) {
					return (
						'src="' +
						p1 +
						'&start=' +
						startTime +
						'&autoplay=0&mute=0&rel=0'
					);
				} else {
					return (
						'src="' +
						p1 +
						'?start=' +
						startTime +
						'&autoplay=0&mute=0&rel=0'
					);
				}
			});
		} else {
			// Just add autoplay if no start time
			embedCode = embedCode.replace(/src="([^"]+)/, function (match, p1) {
				if (p1.includes('?')) {
					return 'src="' + p1 + '&autoplay=0&mute=0&rel=0';
				} else {
					return 'src="' + p1 + '&autoplay=0&mute=0&rel=0';
				}
			});
		}

		// Insert the modified embed code
		$('#video-embed-area').html(embedCode);

		// Get the iframe element
		const iframe = $('#video-embed-area iframe')[0];

		// Create YouTube player from the iframe
		const player = new YT.Player(iframe, {
			events: {
				onReady: function (event) {
					// Explicitly play the video when ready
					event.target.playVideo();

					// Attempt to unmute after a short delay
					setTimeout(function () {
						try {
							event.target.unMute();
							event.target.setVolume(80);
						} catch (e) {
							console.log('Could not unmute video:', e);
						}
					}, 1000);
				},
			},
		});

		// For slide to slide index, use a more reliable approach:
		setTimeout(function () {
			const sliderElement = document.querySelector(
				'.modal-thumbnails-slider'
			);
			if (sliderElement && sliderElement.swiper && slideIndex) {
				const index = parseInt(slideIndex, 10);
				if (!isNaN(index)) {
					sliderElement.swiper.slideTo(index, 300, false);
				}
			}
		}, 100);
	}
}

	jQuery('.modal .close').click(function (e) {
		e.preventDefault();
		const modal = $(this).closest('.modal');
		$('body').removeClass('modal-active');
		$('.modal').removeClass('show').removeClass('fadein');
		pauseAllVideos(modal);
		$('.nl-podcast--inner').css({
			'pointer-events': 'auto',
			'touch-action': 'auto',
			'position': 'relative',
			'z-index': '1'
		});
	});

	let modalCloseTimeout = null;
	let isModalClosing = false;

	const modalCloseHandler = function (e) {
		var target = jQuery(e.target);
		const activeModal = $('.modal.show');

		if (!activeModal.length) {
			return;
		}

		// Prevent multiple rapid events from triggering
		if (isModalClosing) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			return false;
		}

		const isVerticalScrollbarClick = (e) => {
			const rect = e.target.getBoundingClientRect();
			return (e.clientX > rect.left + rect.width - 20);
		};

		if (
			!target.closest('.modal-content').length &&
			!target.closest('.modal-content-holder').length &&
			!isVerticalScrollbarClick(e)
		) {
			// Prevent event from bubbling and triggering clicks on elements below the modal
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			
			isModalClosing = true;
			
			if (modalCloseTimeout) {
				clearTimeout(modalCloseTimeout);
			}
			
			modalCloseTimeout = setTimeout(() => {
				$('body').removeClass('modal-active');
				$('.modal').removeClass('show');
				if (activeModal.attr('id') !== 'video-modal') {
					pauseAllVideos(activeModal);
				}
				setTimeout(() => {
					$('.nl-podcast--inner').css({
						'pointer-events': 'auto',
						'touch-action': 'auto',
						'position': 'relative',
						'z-index': '1'
					});
					isModalClosing = false;
				}, 100);
			}, 50);
			
			return false;
		}
	};

	document.documentElement.addEventListener('click', modalCloseHandler, false);
	document.documentElement.addEventListener('touchstart', modalCloseHandler, {passive: false});
	document.documentElement.addEventListener('pointerdown', modalCloseHandler, {passive: false});
	document.documentElement.addEventListener('MSPointerDown', modalCloseHandler, {passive: false});

	function pauseAllVideos(modal, game_theory) {
		var videos = document.querySelectorAll('video:not(.background):not(.game-theory-video)');
		var iframes = document.querySelectorAll('iframe');
		let src = '';

		videos.forEach(function (video) {
			if (!video.paused) {
				video.pause();
			}
		});

		if (modal) {
			modal.find('iframe').each(function () {
				const iframe = this;
				src = iframe.getAttribute('src');
				iframe.removeAttribute('src');
				iframe.setAttribute('src', src);
			});
		} else {
			iframes.forEach(function (iframe) {
				src = iframe.getAttribute('src');
				iframe.removeAttribute('src');
				iframe.setAttribute('src', src);
			});
		}
	}
};

export const focusAreaActivePage = () => {
	$(document).ready(function () {
		var currentUrl = window.location.href;
		$('#focus-area-menu li').each(function () {
			var menuItemUrl = $(this).find('a').attr('href');
			if (menuItemUrl === currentUrl) {
				$(this).addClass('active');
			}
		});
	});

	let menu = $('#focus-area-menu');
	if ($(menu).find('a[target="_blank"]').length > 0) {
		$(menu).find('li').on('click', function () {
			$(menu).find('li').removeClass('active');
			$(this).addClass('active');
		});
	}
};

export const firstSlideCaption = () => {
	$(document).ready(function () {
		let activeSlide = $('.swiper-slide-active');
		let caption = activeSlide.data('caption');
		let linkSlide = activeSlide.data('url');
		$('.img-caption').text(caption);
		if (linkSlide){
			$('.img-caption').attr('href', linkSlide);
		} else {
			$('.img-caption').removeAttr('href');
		}

		let activeSlideModal = $('.image-slider-modal .swiper-slide-active');
		let captionModal = activeSlideModal.data('caption');
		let linkModal = activeSlideModal.data('url');
		$('.img-caption-modal').text(captionModal);
		if (linkModal) {
			$('.img-caption-modal').attr('href', linkModal);
		} else {
			$('.img-caption-modal').removeAttr('href');
		}
	});
};


export const Cyber60 = () => {
	$(document).ready(function () {
		const sectionBoxes = $(
			'.cyber-content .cyber-section-box[id], .cyber-content .the-cyber-60[id]'
		);
		const tocList = $('.cyber-toc-list:not(.research-toc)');

		sectionBoxes.each(function (index) {
			const heading = $(this).find('h3:first:not(.hide-in-toc), h2:first:not(.hide-in-toc), span:first + h3:not(.hide-in-toc), h5:first:not(.hide-in-toc)');
			if (heading.length) {
				let headingText;

				headingText = heading.first().html().trim();

				const headingId = `section-${index + 1}`;
				$(this).attr('id', headingId);
				const tocItem = $('<li>').html(
					`<a href="#${headingId}">${headingText}</a>`
				);
				tocList.append(tocItem);
			}
		});

		const tocLinks = tocList.find('a');

		//Smooth scroll to target
		$('.cyber-toc-list a, .cyber-hero .tag').on('click', function (e) {
			e.preventDefault();
			$(this).parents('.cyber-toc-list').find('a').removeClass('active');
			$(this).addClass('active');
			var target = $(this).attr('href');
			window.scroller.scrollTo(target, {
				offset: -67,
				duration: 800,
				ease: 'easeInOutQuart',
			});
		});

		$('.gt-navigation a').on('click', function (e) {
			e.preventDefault();
			$(this).addClass('active');
			var target = $(this).attr('href');
			window.scroller.scrollTo(target, {
				offset: -67,
				duration: 800,
				ease: 'easeInOutQuart',
			});
		});

		window.scroller.on('scroll', function () {
			let scrollPosition = $(window).scrollTop();
			let offsetThreshold = 80;

			sectionBoxes.each(function (index) {
				const sectionId = `#section-${index + 1}`;
				const sectionTop = $(this).offset().top - offsetThreshold;
				const sectionHeight = $(this).outerHeight();

				if (
					scrollPosition >= sectionTop &&
					scrollPosition < sectionTop + sectionHeight
				) {
					tocLinks.removeClass('active');
					tocLinks.filter(`[href="${sectionId}"]`).addClass('active');
				}
			});
		});
	});
};

export const classOnLoad = () => {
	let items = document.querySelectorAll('[data-class-on-load]');
	items.forEach((item) => {
		if (item.dataset.classOnLoad && item.dataset.classOnLoad.length > 0) {
			item.classList.add(item.dataset.classOnLoad);
		}
	});
}


export const playVideoOnScroll = () => {
	$(document).ready(function () {
		let players = [];
		$('.vimeo-video').each(function () {
			const iframe = $(this).find('iframe').get(0);
			const player = new Vimeo.Player(iframe);
			let manuallyPaused = false;

			player.on('pause', () => {
				manuallyPaused = true;
			});

			player.on('play', () => {
				manuallyPaused = false;
			});

			players.push({
				player,
				top: $(this).position().top,
				height: $(this).outerHeight(),
				status: 'paused',
				manuallyPaused: () => manuallyPaused
			});
		});

		let viewportHeight = $(window).height();

		scroller.on('scroll', function (position) {
			var scrollPos = position.scroll.y;
			for (var i = 0; i < players.length; i++) {
				var elementTop = players[i].top;
				var elementBottom = elementTop + players[i].height;

				var inViewport =
					scrollPos + viewportHeight > elementTop &&
					scrollPos < elementBottom;

				if (inViewport && players[i].status !== 'play' && !players[i].manuallyPaused()) {
					players[i].status = 'play';
					players[i].player.play();
				}
			}
		});
	});
};


export const TreeTabs = () => {
	$('[data-tab]').click(function (e) {
		e.preventDefault();
		var tab_id = $(this).attr('data-tab');
		$(this).parent().siblings().find('[data-tab]').removeClass('active');
		$('#' + tab_id)
			.siblings()
			.fadeOut(310);
		$(this).addClass('active');
		setTimeout(function () {
			$('#' + tab_id).fadeIn(300);
		}, 305);
	});
	$('#' + $('[data-tab].active').data('tab')).addClass('active');
};


export const Marquee = () => {
    const marqueeLeft = () => {
        const marqueeLeft = $('[data-marquee-left]').marquee({
            speed: 40,
            gap: 66,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            duplicateCount: 4,
            pauseOnHover: false,
            startVisible: true,
        });

			const marqueeRight = $('[data-marquee-right]').marquee({
				speed: 40,
				gap: 66,
				delayBeforeStart: 0,
				direction: 'right',
				duplicated: true,
				duplicateCount: 4,
				pauseOnHover: false,
				startVisible: true,
			});
    }

	const marqueeLeft2 = () => {
		const marqueeLeft2 = $('[data-marquee-left-2]').marquee({
			speed: 40,
			gap: 66,
			delayBeforeStart: 0,
			direction: 'left',
			duplicated: true,
			duplicateCount: 4,
			pauseOnHover: false,
			startVisible: true,
		});
	};

    marqueeLeft();
	marqueeLeft2();
}
export const ImageWidth = () => {
	$('[data-width]').each(function() {
		let item = $(this)
		const widths = item.data('width').split(',')
		const reload = () => {
			if($(window).width() >= 1280) {
				item.width(parseInt(widths[0]))
			} else if ($(window).width() < 1280 && $(window).width() >= 1024) {
				item.width(parseInt(widths[1]))
			} else if ($(window).width() < 1024) {
				item.width(parseInt(widths[2]))
			}
		}

		reload()
		$(window).on('resize', reload)
	});
}

const videosData = window.videosData || [];


export const extractYoutubeData = () => {

    // Function to format view counts
   function formatViewCount(count) {
        if (count >= 1000000) {
            return (count / 1000000).toFixed(1) + 'M views';
        } else if (count >= 1000) {
            return (count / 1000).toFixed(1) + 'K views';
        } else {
            return count + ' views';
        }
    }

    // API Key for YouTube Data API
    const API_KEY = 'AIzaSyBL_rLVlJvDQq7JDjW_dtN2KpGpd_r8Dw0';
    const DEFAULT_CHANNEL_ICON = '/wp-content/themes/lsvp/assets/images/default-channel-icon.jpg';

    // Process thumbnail images
    $('.thumbnail-image').each(function() {
        const $imageElement = $(this);
        const videoId = $imageElement.attr('data-video-id');

        // Skip if this specific element has already been touched for image purposes
        if ($imageElement.hasClass('youtube-image-processed')) {
            return;
        }
        $imageElement.addClass('youtube-image-processed');

        // Always show default channel icon regardless of videoId
        $imageElement.html(`
            <div class="channel-icon">
                <img src="${DEFAULT_CHANNEL_ICON}" alt="LSVP">
            </div>
        `);
    });

    // Process view counts separately
    $('.thumbnail-guest.views').each(function() {
        const $viewsElement = $(this);
        const videoId = $viewsElement.attr('data-video-id');

        // Skip if this specific element has already been touched for views purposes
        if ($viewsElement.hasClass('youtube-views-processed')) {
            return;
        }
        $viewsElement.addClass('youtube-views-processed');


        if (!videoId || videoId === '$video_id' || videoId.trim() === '') {
            // If videoId is missing, or is the placeholder, or empty string
            $viewsElement.text(''); // Or 'Views N/A' or hide
        } else {
            // Valid videoId, fetch view count
            $viewsElement.text('Loading views...');
            $.ajax({
                url: 'https://www.googleapis.com/youtube/v3/videos',
                data: { part: 'statistics', id: videoId, key: API_KEY },
                dataType: 'json',
                success: function(data) {
                    if (data.items && data.items.length > 0) {
                        const viewCount = parseInt(data.items[0].statistics.viewCount);
                        const formattedCount = formatViewCount(viewCount);
                        $viewsElement.text(formattedCount);
                    } else {
                        $viewsElement.text('Views not available');
                    }
                },
                error: function(error) {
                    console.error('Error fetching video stats for views:', error);
                    $viewsElement.text('Unable to load views');
                }
            });
        }
    });
};
